import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { DataIndexClientService } from '@mode/queries/schemas/data-access';
import { SearchClientService } from '@mode/algolia/domain';
import { AlgoliaSuggestionService } from '~/plugins/ace/completion-providers/algolia-suggestion.service';
import { DualDispatchSuggestionService } from '~/plugins/ace/completion-providers/dual-dispatch-suggestion.service';
import { FeatureFlag } from '@mode/shared/contract-common';
import { getInitialFlagValue } from '@mode/shared/util-js';

export const DowngradedSharedDataAccessAlgoliaModule = angular
  .module('downgraded-shared-data-access-algolia', [])
  .service('DataIndexClientService', downgradeInjectable(DataIndexClientService))
  .service('SearchClientService', downgradeInjectable(SearchClientService))
  .service(
    'SuggestionService',
    getInitialFlagValue(FeatureFlag.AlgoliaToOpenSearchAutocomplete)
      ? downgradeInjectable(DualDispatchSuggestionService)
      : downgradeInjectable(AlgoliaSuggestionService)
  ).name;
